import React from 'react';
import Zoom from "react-reveal/Zoom"; 
import image from '../assets/my pic.jpg'
const AboutMe = () => {
    return (
      <div id='aboutme' className="flex bg-[#1f1f38] text-white lg:flex-row justify-center pt-10 lg:px-20 sm:flex flex-col-reverse sm:px-0">
        <div className=" mx-5  sm:w-full"> 
          <img src={image} className='w-10/12 sm:mx-auto' alt=''/>
        </div>
        <Zoom>
          <div className="lg:w-3/4 lg:px-20 sm:px-5 mx-5 sm:w-full">
          <h2 className="text-4xl font-bold text-center text-white mb-10">
        MY PROJECTS
      </h2>
            <p>
              Hi, My name is Kaniz Fatema. I have completed Bachelor's
              Degree in Computer science from International Islamic University
              Chittagong. I am an innovative MERN Stack developer with 1 years+
              of experience building responsive websites. Skilled in HTML, CSS,
              Javascript, and Modern Javascript library ReactJs. .
            </p>
            <h3 className="text-xl font-semibold">My Contact Information</h3>
            <p>
              <strong>Phone : </strong>
              018405229829            </p>
            <p>
              <strong>Email : </strong>
              kanizfatema0184@gmail.com
            </p>

           
          </div>
        </Zoom>
      </div>
    );
};

export default AboutMe;